import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';

if (typeof Highcharts === 'object') {
    Exporting(Highcharts);
    ExportData(Highcharts);
    // Group long numbers with commas (e.g. 2,345) across all charts that use this instance.
    Highcharts.setOptions({ lang: { thousandsSep: ',' } });
}

export default Highcharts;
